import styled from 'styled-components/macro';

import HeadingBase from '@components/common/core/DataDisplay/Heading';

export const HeaderWrapper = styled.div`
  margin-bottom: 32px;
`;

export const Title = styled(HeadingBase)``;
